import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Access, Iaccess } from "../shared/access.model";
import { NotificationService, LoaderService, EVENTO, TOOLTIPS, ICONS, ACTIONS } from "../../../../shared/session/index";
import { AccessService } from '../shared/access.service';
import { RegularExpressionMessage, RegularExpression, CustomValidators } from '../../../../shared/validation/customvalidation';
import { AplicacionService } from '../../Aplicaciones/shared/aplicacion.service';
import { Aplicacion } from '../../Aplicaciones/shared/aplicacion.model';
import { ModuleService } from '../../modules/shared/module.service';
import { Module } from '../../modules/shared/module.model';

@Component({
  //moduleId: module.id,
  selector: 'app-access-edit',
  templateUrl: 'access-edit.component.html'
})

export class AccessEditComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;

  formGrupEditAccess: FormGroup;
  buttonGroup: any;
  access: Iaccess;
  nomAccessMaxLength: number;
  descriptionMaxLength: number;
  msgErrorActualizar: string;
  msgErrorGet: string;
  msgSuccessInsert: string;
  msgErrorInsert: string;
  obligatorioMsg: string;
  maxLengthMsg: string;
  accessName: string;
  descripcionMaxLength: number;
  nomAccessPatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;
  nomPathMaxLength: number;
  msgErrorGetAplicaciones: string;

  aplicaciones: Aplicacion[];
  modules: Module[];

  constructor(
    private loaderService: LoaderService,
    private accessService: AccessService,
    private notificationService: NotificationService,
    private aplicacionService: AplicacionService,
    private moduleService: ModuleService,
    public fb: FormBuilder
  ) { }

  ngOnInit() {
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];

    this.msgErrorActualizar = 'Error al actualizar datos';
    this.msgErrorGet = 'Error al obtener datos';
    this.msgErrorGetAplicaciones = "Error al listar las aplicaciones";
    this.access = new Access(0, 1, "", "", "", "", "", true, "", "", "", "", "", "",1);
    this.setValuesFormBuilder();
    this.listarAplicacionCbo();
    this.obtenerAccess(this.data.access.ID);
  }

  private setValuesFormBuilder() {
    this.formGrupEditAccess = this.fb.group({
      accessName: [this.access.Name, Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomAccessMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      path: [this.access.Path, Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomPathMaxLength)
      ])],
      description: [this.access.Description, Validators.compose([
        Validators.maxLength(this.descripcionMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      status: [this.access.Status],
      aplicacionID: [this.access.AplicacionID],
      moduleID: [this.access.ModuleID],
    });
  }

  formGrupEditAccessSubmit(event) {
    if (this.formGrupEditAccess.invalid)
      return;

    this.access.Name = event.value.accessName
    this.access.Description = event.value.description;
    this.access.Path = event.value.path;
    this.access.Status = event.value.status,
    this.access.AplicacionID = event.value.aplicacionID;
    this.access.ModuleID = event.value.moduleID;

    this.actualizarAccess(this.access);
  }

  modulesByApplication(){
    this.listarPorModuleCbo('',Number(this.formGrupEditAccess.get('aplicacionID').value))
  }

  changeEvent(access: Iaccess) {
    this.data.access = access;
    this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
  }

  private actualizarAccess(access: Iaccess) {
    this.loaderService.show();
    this.accessService.actualizarAccess(access)
    .subscribe(res => {
      this.changeEvent(access);
    },
    error => {
      this.notificationService.error(this.msgErrorActualizar);
      throw error;
    },
    () => {
      this.loaderService.hide();
    });
  }

  private obtenerAccess(accessID: number): void {
    this.loaderService.show();
    this.accessService.obtenerAccess(accessID)
    .subscribe(res => {
      this.access = res;
    },
    error => {
      this.notificationService.error(this.msgErrorGet);
      throw error;
    },
    () => {
      this.setValuesFormBuilder();
      this.loaderService.hide();
    });
  }

  private listarAplicacionCbo(): void {
    this.loaderService.show();
    this.aplicacionService.listarApplication()
    .subscribe(res => {
      this.aplicaciones = res;
    },
    error => {
      this.notificationService.error(this.msgErrorGetAplicaciones);
      throw error;
    },
    () => {
      this.modulesByApplication()
      this.loaderService.hide();
    });
  }

  private listarPorModuleCbo(filtro: string, pAplicacionID: number): void {
    this.loaderService.show();
    this.moduleService.listarPorModulos(filtro, pAplicacionID, 0, 0)
      .subscribe(res => {
        this.modules = res;
      },
        error => {
          this.notificationService.error(this.msgErrorGetAplicaciones);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }
}
